import { AvatarWrapper } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

const AVATAR_SIZE = {
  sm: 'xs',
  md: 'default',
  lg: 'md'
};

export default function LiveChallengeAuthor({ user, size = 'md', variant = 'light', withLabel = true, className }) {
  if (!user) return null;

  const isDark = variant === 'dark';
  const regional = user?.institution?.regional?.name;
  const institutionName = user?.institution?.name;
  const subtitle = [regional, institutionName].filter(Boolean).join(' · ');

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <AvatarWrapper
        size={AVATAR_SIZE[size] ?? 'default'}
        src={user.image}
        text={user.name}
        className="shrink-0"
      />

      <div className="min-w-0 flex-1">
        {withLabel && <p className={cn('mb-0 truncate text-[11px] uppercase tracking-wide', isDark ? 'text-white/70' : 'text-neutral-light')}>Criado por</p>}
        <p
          className={cn('mb-0 truncate text-sm font-semibold', isDark ? 'text-white' : 'text-neutral-dark')}
          title={user.name}
        >
          {user.name}
        </p>
        {subtitle && (
          <p
            className={cn('mb-0 truncate text-xs font-light', isDark ? 'text-white/80' : 'text-neutral')}
            title={subtitle}
          >
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
